import { useBrand } from 'hooks/useBrand'
import { useLayoutEffect, useRef } from 'react'
import { HeaderDesktop } from './HeaderDesktop'
import { HeaderMobile } from './HeaderMobile'
import { useHeader } from './useHeader'

export const HeaderAssociationUI = (props: ReturnType<typeof useHeader>) => {
  const { config } = useBrand()
  const headerRef = useRef<HTMLElement>(null)

  /**
   * Mesma mecânica do HeaderUI: o header é `fixed`, então o conteúdo precisa de um
   * deslocamento igual à sua altura. Sem publicar `--header-h` aqui, as rotas de
   * associados dentro do Layout caíam no fallback de 120px e o conteúdo colava no header.
   */
  useLayoutEffect(() => {
    const element = headerRef.current
    if (!element) return undefined

    const publishHeight = () => {
      const { height } = element.getBoundingClientRect()
      if (height > 0) document.documentElement.style.setProperty('--header-h', `${Math.round(height)}px`)
    }

    publishHeight()

    if (typeof ResizeObserver === 'undefined') return undefined

    const observer = new ResizeObserver(publishHeight)
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  return (
    <header
      ref={headerRef}
      id="header-home"
      className="fixed top-0 z-10 flex h-auto w-full flex-col items-center justify-center text-neutral-800"
      style={{ backgroundColor: config.headerBackground ?? config.colors.primary }}>
      <div className="hidden w-full lg:block">
        <HeaderDesktop {...props} />
      </div>

      <div className="block w-full lg:hidden">
        <HeaderMobile {...props} />
      </div>
    </header>
  )
}
